// Sentry `environment` shared by alldrivers-web and alldrivers-react-native, with
// the same names as the backend (backend/alldrivers/settings.py) and the CI deploy
// markers: production | staging | development. `preview` builds (staging web
// image, EAS preview channel) talk to dev.alldrivers.pt, so they are staging.
// Alert rules filter on environment:production; anything not proven production
// must never land there (ALL-29).
const SENTRY_ENVIRONMENT_BY_VARIANT: Record<string, string> = {
  production: 'production',
  preview: 'staging',
  development: 'development',
};

export function sentryEnvironmentFor(appVariant: string | undefined, override?: string): string {
  const explicit = (override || '').trim();
  if (explicit) {
    return explicit;
  }
  const variant = (appVariant || '').trim().toLowerCase();
  return SENTRY_ENVIRONMENT_BY_VARIANT[variant] || variant || 'unknown';
}
